module.exports = __webpack_public_path__ + "img/sidenav-item-new-order.0d464cc6.svg";